// Owner: integrations (owner feedback F22). Settings › Connections › Apps: Attio, HTTP / REST, GitHub and the
// catalog; one app opens as a detail (`?app=<id>`, GitHub as `?app=github`).
// settings-ia: owned by data/work/system agent (cross-links) — the former Connections › Apps view, as is.
import { createFileRoute } from '@tanstack/react-router';
import { AppsConnectionsPage } from '../../../features/integrations/apps/AppsConnectionsPage';
import { AppsSearch } from '../../../features/integrations/apps/search';

export const Route = createFileRoute('/_settings/settings/apps')({
  validateSearch: AppsSearch,
  component: AppsRoute,
});

function AppsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AppsConnectionsPage
      search={search}
      onSearch={(next) => void navigate({ search: next, replace: false })}
    />
  );
}
